import React from "react"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"

import { Team } from "entities/teams/types/Team"
import { ProjectTeamPopover } from "features/project-team/ui/project-team-popover/ProjectTeamPopover"

import { useProjectFormContext } from "../contexts/ProjectFormContext"

export interface ProjectFormTeamButtonProps extends WithClassName {
  team?: Team | null
  email?: string | null
  onManage?: () => void
}

export const ProjectFormTeamButton = React.memo(
  ({
    team: teamProp,
    email,
    className,
    onManage: onManageProp
  }: ProjectFormTeamButtonProps) => {
    const { model } = useProjectFormContext()
    const team = teamProp ?? null
    const onManage =
      onManageProp ?? model?.team.handlers.onInviteMember ?? undefined

    if (!team) {
      return null
    }

    return (
      <ProjectTeamPopover
        team={team}
        email={email}
        onManage={onManage}
        className={classNames("project-form__team-button", className)}
      />
    )
  }
)

ProjectFormTeamButton.displayName = "ProjectFormTeamButton"
